import api from '../index'

export const getAllteamApi = (id) => api.post('getemployeelist', id);
export const AssignPermissionApi = (data) => api.post('add-permission-to-employee', data);
export const ChangeEmployeeStatusApi = (data) => api.post('update-user-status', data);
